import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import type { RouteObject } from 'react-router-dom';

const ListPage = lazy(() => import('@/features/companies/list/page'));
const CreatePage = lazy(() => import('@/features/companies/create/page'));
const CompanyLayout = lazy(() => import('@/features/companies/info/CompanyLayout'));
const InfoPage = lazy(() => import('@/features/companies/info/page'));

/**
 * Old Haken's Company page bundled "general data" + contacts + work
 * places under a single 3-step Stepper. Relay mirrors that: one
 * page per company id, no sub-routes for individual resources.
 *
 * `/companies/list` + `/companies/info` redirect to the canonical
 * relay paths so Company.md spec URLs + old Haken bookmarks resolve.
 */
export const companiesRoutes: RouteObject[] = [
  { path: 'companies', element: <ListPage /> },
  { path: 'companies/new', element: <CreatePage /> },
  { path: 'companies/list', element: <Navigate to="/companies" replace /> },
  { path: 'companies/info', element: <Navigate to="/companies/new" replace /> },
  {
    path: 'companies/:id',
    element: <CompanyLayout />,
    children: [{ index: true, element: <InfoPage /> }],
  },
];
